/* eslint-disable no-console */
import {
    LoggerContext, LoggerLevel, LogObject, Transport,
} from 'src/types';

export const consoleTransporter: Transport = ({
    name: 'console',
    log: (
        level: LoggerLevel,
        payload: LogObject,
        context: LoggerContext,
        error: Error | null | undefined,
    ): void => {
        switch (level) {
            case 'critical':
                console.error(payload, context, error || undefined);
                break;
            case 'debug':
                console.trace(payload, context, error || undefined);
                break;
            case 'error':
                console.error(payload, context, error || undefined);
                break;
            default:
                console.info(payload, context, error || undefined);
                break;
        }
    },
});
